export function searchFunction1(performanceCurveData: any[], airflow: number): number {

  let selectedPerformanceCurve: any = {
    flow: 0,
    plotPoints: []
  };

  let selectedPlotPoint: any = {
    efficiency: 0
  };

  for (let i = 0; i < performanceCurveData.length; i++) {

    if (performanceCurveData[i].flow < airflow) {

      if (performanceCurveData[i].flow > selectedPerformanceCurve.flow) {

        selectedPerformanceCurve = performanceCurveData[i];

      }

    } else {
      break;
    }

  }

  for (let j = 0; j < selectedPerformanceCurve.plotPoints.length; j++) {

    if (selectedPerformanceCurve.plotPoints[j].efficiency > selectedPlotPoint.efficiency) {

      selectedPlotPoint = selectedPerformanceCurve.plotPoints[j];

    }

  }

  return selectedPlotPoint.efficiency


}

export function searchFunction3(performanceCurveData: any[], req_airflow: number, rpm2: number, rpm1: number, air_density2: string, air_density1: number, netFreeArea: number, curveType: boolean, pressure: number): any {
  // console.log(performanceCurveData,req_airflow);
  // let selectedPerformanceCurve: any = {
  //     flow: 0,
  //     plotPoints: []
  // };

  // for (let i = 0; i < performanceCurveData.length; i++) {

  //     if(performanceCurveData[i].flow > selectedPerformanceCurve.flow){

  //         selectedPerformanceCurve = performanceCurveData[i];

  //     }

  // }
  // console.log(selectedPerformanceCurve.flow)
  // return ((selectedPerformanceCurve.flow - req_airflow) * 100/req_airflow);

  console.log(performanceCurveData, req_airflow, rpm2, rpm1, air_density1, air_density2, netFreeArea, curveType, pressure)
  let pvValue = 0;
  let tempGraphPressureData = [];
  let angles: string[] = [];
  let graphHeaderData = ['Airflow'];
  let maxP = 0;
  const data = performanceCurveData
  // Build angles array and headers
  for (let i = 0; i < data.length; i++) {
    for (let j = 0; j < data[i].plotPoints.length; j++) {
      for (let k = 0; k <= angles.length; k++) {
        if (angles.length === 0) {
          angles.push(data[i].plotPoints[j].graphAngle);
          graphHeaderData.push(data[i].plotPoints[j].graphAngle);
        }
        if (data[i].plotPoints[j].graphAngle === angles[k]) {
          break;
        } else if (k === angles.length - 1) {
          angles.push(data[i].plotPoints[j].graphAngle);
          graphHeaderData.push(data[i].plotPoints[j].graphAngle);
        }
      }
    }
  }

  graphHeaderData.push("PV");
  graphHeaderData.push("System Res Cu (t)");

  // setAngles(angles);
  tempGraphPressureData.push(graphHeaderData);
  for (let i = 0; i < data.length; i++) {
    let GraphPressureDataRow = [];
    const pData = data[i].flow * (rpm2 / rpm1);
    console.log("ScalingF", (rpm2 / rpm1), data[i].flow);
    GraphPressureDataRow.push(pData);

    // Calculate PV value for this airflow point first
    pvValue = Math.pow(((data[i].flow) / netFreeArea), 2) * 0.5 * (parseFloat(air_density2));

    for (let j = 1; j < graphHeaderData.length; j++) {
      for (let k = 0; k < data[i].plotPoints.length; k++) {
        if (graphHeaderData[j] === data[i].plotPoints[k].graphAngle) {
          let tp;
          if (curveType) {
            tp = parseFloat(data[i].plotPoints[k].total_pressure)
          } else {
            tp = parseFloat(data[i].plotPoints[k].total_pressure);
          }
          console.log(tp);
          const calculatedPressure = tp * (Number(rpm2) / Number(rpm1)) * (Number(rpm2) / Number(rpm1)) * (parseFloat(air_density2) / Number(air_density1));
          console.log(data[i].plotPoints[k].graphAngle,calculatedPressure);
          // **KEY CHANGE**: Ensure angle line doesn't cross below PV line
          // Angle lines should be above PV line (total pressure >= velocity pressure)
            GraphPressureDataRow.push(calculatedPressure); // this will let the curve line cut the PV line, which is the intended behaviour.
          maxP = calculatedPressure > maxP ? calculatedPressure : maxP;
          break;
        }

        if (graphHeaderData[j] === "PV") {
          GraphPressureDataRow.push(pvValue);
          break;
        }

        if (graphHeaderData[j] === "System Res Cu (t)") {
          const percentage = maxP * 0.3;
          const g7 = data[i].flow * (rpm2 / rpm1);
          if (curveType) {
            let g9: any = Math.pow((g7 / req_airflow), 2) * (Number(pressure)+Number(Math.pow(((req_airflow) / netFreeArea), 2) * 0.5 * (parseFloat(air_density2))));
            console.log("Static Pressure: ",pressure,(Number(pressure)+Number(Math.pow(((req_airflow) / netFreeArea), 2) * 0.5 * (parseFloat(air_density2)))))
            GraphPressureDataRow.push(g9 > (maxP + percentage) ? null : g9);  // this will let the angle curve cut the PV lines. 
          } else {
            const g9 = Math.pow((g7 / req_airflow), 2) * pressure;
            console.log("Total Pressure: ",pressure)
            GraphPressureDataRow.push(g9 > (maxP + percentage) ? null : g9);
          }
          break;
        }

        // Design points
        if (k === (data[i].plotPoints.length - 1)) {
          GraphPressureDataRow.push(null);
        }
      }
    }

    tempGraphPressureData.push(GraphPressureDataRow);
  }
  console.log(tempGraphPressureData);
  /**
* Finds the intersection of an angle curve (e.g., 9°) with the System Res curve.
* Uses piecewise-linear interpolation between known points.
*
* Input format: your 2D array where row[0] is headers.
* Returns: { airflow, pressure, segment } or null if no intersection is found.
*/
  function findAngleSystemIntersection(table2D: any, angleDeg: any) {
    console.log(table2D)
    if (!Array.isArray(table2D) || table2D.length < 3) {
      throw new Error("Invalid table: need headers + at least 2 data rows.");
    }

    const headers = table2D[0];
    const idxAirflow = headers.indexOf("Airflow");
    const idxAngle = headers.indexOf(String(angleDeg));
    const idxSystem = headers.indexOf("System Res Cu (t)");

    if (idxAirflow === -1) throw new Error('Missing header: "Airflow"');
    if (idxAngle === -1) throw new Error(`Missing header: "${String(angleDeg)}"`);
    if (idxSystem === -1) throw new Error('Missing header: "System Res Cu (t)"');

    // Build clean points where both curves have values
    const pts = [];
    for (let i = 1; i < table2D.length; i++) {
      const row = table2D[i];
      const x = row[idxAirflow];
      const pAngle = row[idxAngle];
      const pSys = row[idxSystem];

      const xNum = Number(x);
      const aNum = pAngle === null || pAngle === undefined ? NaN : Number(pAngle);
      const sNum = pSys === null || pSys === undefined ? NaN : Number(pSys);

      if (Number.isFinite(xNum) && Number.isFinite(aNum) && Number.isFinite(sNum)) {
        pts.push({ x: xNum, a: aNum, s: sNum, rowIndex: i });
      }
    }
    console.log(pts);
    if (pts.length < 2) return null;

    // Sort by airflow just in case
    pts.sort((p1, p2) => p1.x - p2.x);

    // Difference function: angleCurve - systemCurve
    const diff = (p: any) => p.a - p.s;

    // Search for a sign change across consecutive segments
    for (let i = 0; i < pts.length - 1; i++) {
      const p0 = pts[i];
      const p1 = pts[i + 1];

      const f0 = diff(p0);
      const f1 = diff(p1);

      // Exact hit at a known point
      if (f0 === 0) {
        return {
          airflow: p0.x,
          pressure: p0.a, // same as p0.s
          segment: { fromRow: p0.rowIndex, toRow: p0.rowIndex }
        };
      }

      // Need a sign change (or crossing through zero)
      if ((f0 < 0 && f1 > 0) || (f0 > 0 && f1 < 0) || f1 === 0) {
        // Linear interpolation on f(x) between x0 and x1
        const x0 = p0.x, x1 = p1.x;
        const t = (0 - f0) / (f1 - f0); // in [0,1] when crossing is inside segment
        const xStar = x0 + t * (x1 - x0);

        // Interpolate pressure on each curve (they should match at intersection)
        const aStar = p0.a + t * (p1.a - p0.a);
        const sStar = p0.s + t * (p1.s - p0.s);

        return {
          airflow: xStar,
          pressure: (aStar + sStar) / 2, // average to reduce tiny numeric mismatch
          segment: { fromRow: p0.rowIndex, toRow: p1.rowIndex }
        };
      }
    }

    // No intersection found within given range.
    // If you want extrapolation, uncomment the block below.

    /*
    // Extrapolate using last two points (or first two) if desired:
    const p0 = pts[pts.length - 2];
    const p1 = pts[pts.length - 1];
    const f0 = diff(p0), f1 = diff(p1);
    if (f1 !== f0) {
      const t = (0 - f0) / (f1 - f0);
      const xStar = p0.x + t * (p1.x - p0.x);
      const aStar = p0.a + t * (p1.a - p0.a);
      const sStar = p0.s + t * (p1.s - p0.s);
      return { airflow: xStar, pressure: (aStar + sStar) / 2, extrapolated: true };
    }
    */

    return null;
  }

  /* ------------------ Example usage with your data ------------------ */
  // var data = tempGraphPressureData;
  // console.log(tempGraphPressureData[0].at(-3))
  const hit = findAngleSystemIntersection(tempGraphPressureData, tempGraphPressureData[0].at(-3));
  console.log(hit);
  // -> { airflow: ..., pressure: ..., segment: { fromRow: ..., toRow: ... } } or null
  return hit;
}

export function searchFunction4(performanceCurveData: any[], pressure: number): number {

  let selectedPlotPoint: any = {
    static_pressure: 0
  };

  for (let i = 0; i < performanceCurveData.length; i++) {

    for (let j = 0; j < performanceCurveData[i].plotPoints.length; j++) {

      if (performanceCurveData[i].plotPoints[j].static_pressure > selectedPlotPoint.static_pressure) {

        selectedPlotPoint = performanceCurveData[i].plotPoints[j];

      }

    }

  }

  return ((selectedPlotPoint.static_pressure - pressure) * 100 / pressure);

}